import axios from 'axios'

export default {
    getCustomers() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/customers').then((response) => {
            return response
        })
    },
    getCustomer(customerId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/customers/' + customerId).then((response) => {
            return response
        })
    },
    createCustomer(customer) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/customers', customer).then((response) => {
            return response
        })
    },
    editCustomer(customer) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/customers', customer).then((response) => {
            return response
        })
    },
    deleteCustomer(customerId) {
        return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/customers/' + customerId).then((response) => {
            return response
        })
    },
    toggleCustomerShowPrices(payload) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/customers/toggleCustomerShowPrices/' + payload.customerId, payload).then((response) => {
            return response
        })
    },
    toggleCustomerAddProducts(payload) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/customers/toggleCustomerAddProducts/' + payload.customerId, payload).then((response) => {
            return response
        })
    },
}
